import React from "react";

import {

    FontAwesomeIcon

}

from "@fortawesome/react-fontawesome";

import {

    faBuilding,

    faCamera

}

from "@fortawesome/free-solid-svg-icons";

import MobileHeader

from "../../home/mobile/components/MobileHeader";

import MobileGiraffeViewer

from "../../scanningvendors/components/MobileGiraffeViewer";

import MobileFacilityDocuments

from "./components/MobileFacilityDocuments";

import MobileFacilityDetails

from "./components/MobileFacilityDetails";



//============================================================
//
// Mobile Facility
//
//============================================================

export default function MobileFacility(

{

    id,

    facilityName,

    facilityCode,

    displayMode,

    scanUrl,

    photoSource

})

{

    //--------------------------------------------------------
    // Display modes
    //--------------------------------------------------------

    const DISPLAY_SCAN =
        "SCAN";

    const DISPLAY_PHOTO =
        "PHOTO";



    //--------------------------------------------------------
    // Responsive
    //--------------------------------------------------------

    const screenWidth =
        window.innerWidth;

    const isTablet =
        screenWidth > 768
        &&
        screenWidth <= 1200;



    //========================================================
    //
    // Styles
    //
    //========================================================

    const page =
    {

        position:
            "relative",

        width:
            "100%",

        minHeight:
            "100vh",

        overflowX:
            "hidden",

        overflowY:
            "auto",

        background:
            "#f3f5f7",

        boxSizing:
            "border-box"

    };



    //--------------------------------------------------------
    // Scan / photo
    //--------------------------------------------------------

    const mediaSection =
    {

        position:
            "relative",

        width:
            "100%",

        height:
            isTablet
                ?
                "calc(100vh - 70px)"
                :
                "52vh",

        minHeight:
            isTablet
                ?
                "500px"
                :
                "390px",

        maxHeight:
            isTablet
                ?
                "none"
                :
                "520px",

        background:
            "#111827",

        overflow:
            "hidden"

    };



    const photo =
    {

        display:
            "block",

        width:
            "100%",

        height:
            "100%",

        objectFit:
            "cover"

    };



    const noMedia =
    {

        display:
            "flex",

        width:
            "100%",

        height:
            "100%",

        flexDirection:
            "column",

        alignItems:
            "center",

        justifyContent:
            "center",

        gap:
            "12px",

        color:
            "rgba(255,255,255,0.72)",

        background:
            `
                linear-gradient(
                    180deg,
                    #1f2937 0%,
                    #111827 100%
                )
            `

    };



    const noMediaIcon =
    {

        fontSize:
            "34px",

        opacity:
            0.65

    };



    const noMediaText =
    {

        fontSize:
            "13px",

        fontWeight:
            600,

        letterSpacing:
            "0.2px"

    };



    //========================================================
    //
    // Building title
    //
    //========================================================

    const buildingHeader =
    {

        position:
            "relative",

        width:
            isTablet
                ?
                "calc(100% - 60px)"
                :
                "calc(100% - 20px)",

        maxWidth:
            isTablet
                ?
                "720px"
                :
                "none",

        margin:
            isTablet
                ?
                "-58px auto 16px auto"
                :
                "-22px 10px 12px 10px",

        padding:
            isTablet
                ?
                "15px 20px"
                :
                "17px 18px",

        boxSizing:
            "border-box",

        background:
            "rgba(255,255,255,0.92)",

        backdropFilter:
            "blur(18px)",

        WebkitBackdropFilter:
            "blur(18px)",

        border:
            "1px solid rgba(255,255,255,0.72)",

        borderRadius:
            isTablet
                ?
                "16px"
                :
                "14px",

        boxShadow:
            "0 8px 24px rgba(0,0,0,0.16)",

        zIndex:
            10

    };



    const buildingTitleRow =
    {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "12px"

    };



    const buildingPuck =
    {

        display:
            "flex",

        width:
            "40px",

        height:
            "40px",

        flexShrink:
            0,

        alignItems:
            "center",

        justifyContent:
            "center",

        borderRadius:
            "50%",

        color:
            "#ffffff",

        background:
            "linear-gradient(180deg, #1f2937 0%, #111827 100%)",

        boxShadow:
            `
                inset 0 1px 2px rgba(255,255,255,0.35),
                inset 0 -2px 4px rgba(0,0,0,0.25),
                0 4px 10px rgba(0,0,0,0.22)
            `

    };



    const buildingTitleContainer =
    {

        minWidth:
            0,

        flexGrow:
            1

    };



    const buildingNameStyle =
    {

        color:
            "#26313D",

        fontSize:
            isTablet
                ?
                "18px"
                :
                "17px",

        fontWeight:
            700,

        lineHeight:
            "21px"

    };



    const buildingCodeStyle =
    {

        marginTop:
            "3px",

        color:
            "#7A8490",

        fontSize:
            "11px",

        fontWeight:
            500

    };



    //========================================================
    //
    // Information area
    //
    //========================================================

    const informationArea =
    {

        display:
            isTablet
                ?
                "grid"
                :
                "block",

        gridTemplateColumns:
            isTablet
                ?
                "minmax(0, 1fr) minmax(0, 1fr)"
                :
                "none",

        alignItems:
            "start",

        gap:
            isTablet
                ?
                "14px"
                :
                "0px",

        width:
            isTablet
                ?
                "calc(100% - 20px)"
                :
                "100%",

        margin:
            isTablet
                ?
                "0px 10px"
                :
                "0px",

        boxSizing:
            "border-box"

    };



    //--------------------------------------------------------
    // Tablet columns
    //--------------------------------------------------------

    const informationColumn =
    {

        minWidth:
            0,

        width:
            "100%"

    };



    //========================================================
    //
    // Media
    //
    //========================================================

    const renderMedia =

        function()

        {

            //------------------------------------------------
            // Scan takes priority
            //------------------------------------------------

            if(

                displayMode === DISPLAY_SCAN

                &&

                scanUrl

            )

            {

                return (

                    <MobileGiraffeViewer

                        url={scanUrl}

                    />

                );

            }



            //------------------------------------------------
            // Then photo
            //------------------------------------------------

            if(

                displayMode === DISPLAY_PHOTO

                &&

                photoSource

            )

            {

                return (

                    <img

                        src={photoSource}

                        alt={

                            facilityName ||

                            "Building"

                        }

                        style={photo}

                    />

                );

            }



            //------------------------------------------------
            // Nothing available
            //------------------------------------------------

            return (

                <div style={noMedia}>

                    <FontAwesomeIcon

                        icon={faCamera}

                        style={noMediaIcon}

                    />



                    <div style={noMediaText}>

                        No photo or scan available

                    </div>

                </div>

            );

        };



    //========================================================
    //
    // Render
    //
    //========================================================

    return (

        <div style={page}>



            {/* ==============================================
                HEADER
            ============================================== */}

            <MobileHeader />



            {/* ==============================================
                SCAN / PHOTO
            ============================================== */}

            <div style={mediaSection}>

                {

                    renderMedia()

                }

            </div>



            {/* ==============================================
                BUILDING TAB
            ============================================== */}

            <div style={buildingHeader}>

                <div style={buildingTitleRow}>

                    <div style={buildingPuck}>

                        <FontAwesomeIcon

                            icon={faBuilding}

                        />

                    </div>



                    <div style={buildingTitleContainer}>

                        <div style={buildingNameStyle}>

                            {

                                facilityName ||

                                "Building"

                            }

                        </div>



                        {

                            facilityCode

                            &&

                            <div style={buildingCodeStyle}>

                                {facilityCode}

                            </div>

                        }

                    </div>

                </div>

            </div>



            {/* ==============================================
                INFORMATION

                PHONE:
                    Details
                    Documents

                TABLET:
                    Details | Documents
            ============================================== */}

            <div style={informationArea}>



                {/* ==========================================
                    DETAILS
                ========================================== */}

                <div style={informationColumn}>

                    <MobileFacilityDetails

                        facilityId={id}

                    />

                </div>



                {/* ==========================================
                    DOCUMENTS
                ========================================== */}

                <div style={informationColumn}>

                    <MobileFacilityDocuments

                        facilityId={id}

                        facilityCode={facilityCode}

                    />

                </div>



            </div>



            {/* ==============================================
                BOTTOM BREATHING ROOM
            ============================================== */}

            <div

                style={{

                    height:
                        isTablet
                            ?
                            "40px"
                            :
                            "30px"

                }}

            />



        </div>

    );

}